import type { DateValue } from '@internationalized/date';
import { Writable, writable } from 'svelte/store';

export const dateValue: Writable<DateValue | undefined> = writable(undefined);

export const selectedPrice: Writable<{
    originalPrice: number | null; // formatCurrency(date.priceWithCustomerCarbonContribution) ou null (hidden)
    rebateAmount: string | null; // date.rebateAmount ou null (hidden)
    actualPrice: number | null; // date.rebatedPriceWithCustomerCarbonContribution OU date.priceWithCustomerCarbonContribution
}> = writable({
    originalPrice: null,
    rebateAmount: null,
    actualPrice: null,
});
